// Define mywork constants

module.exports = {
  TOPMENU_UPDATE_ACTIVE: 'TOPMENU_UPDATE_ACTIVE',
  TOPMENU_UPDATE_FAVORITES: 'TOPMENU_UPDATE_FAVORITES',
  TOPMENU_UPDATE_RECENT_ITEMS: 'TOPMENU_UPDATE_RECENT_ITEMS',
  TOPMENU_UPDATE_OBJECT_NAME: 'TOPMENU_UPDATE_OBJECT_NAME',
  TOPMENU_UPDATE_BOTTOM_MENU_BUTTON: 'TOPMENU_UPDATE_BOTTOM_MENU_BUTTON',
  OBJECT_TYPE_ACTIVITY: 'activity',
  OBJECT_TYPE_BOARD: 'board',
  OBJECT_TYPE_GOAL: 'goal',
  OBJECT_TYPE_MEETING: 'meeting',
  OBJECT_TYPE_TEAM: 'team',
  OBJECT_TYPE_RBR: 'rbr',
  OBJECT_TYPE_WS: 'workstream',
  OBJECT_TYPE_TEAM_GOAL: 'team_goal',
  OBJECT_TYPE_USER_GOAL: 'user_goal',

  RECENT_TYPE_ACTIVITY: 'recent_activity',
  RECENT_TYPE_BOARD: 'recent_board',
  RECENT_TYPE_GOAL: 'recent_goal',
  RECENT_TYPE_MEETING: 'recent_meeting',
  RECENT_TYPE_TEAM: 'recent_team',
  RECENT_TYPE_RBR: 'recent_rbr',
  RECENT_TYPE_WS: 'recent_workstream',
  TOPMENU_DELETE_OBJECT: 'topmenu_delete_object',
  OBJECT_TYPE_ACTIVITY_MYWORK: 'activity_mywork',
  OBJECT_TYPE_MY_OBJECTIVE: 'myobjective',
  DUMBTHETOPMENU: 'dumbTheTopMenu',
  TOPMENU_SET_PAGE_TITLE: 'TOPMENU_SET_PAGE_TITLE',
  OBJECT_TYPE_PERSONKR: 'personKeyResult',
  TOPMENU_LOAD_MENU_ITEMS: 'TOPMENU_LOAD_MENU_ITEMS',
};
